// ─────────────────────────────────────────────────────────────────
// main.js — Menú desktop + mobile + scroll behavior del header
// ─────────────────────────────────────────────────────────────────

// ── Dropdown desktop ─────────────────────────────────
const adjustDropdownPosition = (dropdown) => {
    const parent = dropdown;
    const childMenu = dropdown.querySelector('ul');
    if (parent && childMenu) {
        const overflow = parent.offsetLeft + parent.offsetWidth + childMenu.offsetWidth > window.innerWidth;
        childMenu.style.right = overflow ? "0" : "auto";
        childMenu.style.left  = overflow ? "auto" : "0";
    }
};

const handleMouseEvents = (event) => {
    const item = event.currentTarget;
    if (window.innerWidth > 950) {
        item.classList.toggle('active', event.type === 'mouseover');
        adjustDropdownPosition(item);
    } else {
        item.classList.remove('active');
    }
};

const initDesktopMenu = () => {
    document.querySelectorAll('.has-submenu').forEach(item => {
        item.removeEventListener('mouseover', handleMouseEvents);
        item.removeEventListener('mouseout',  handleMouseEvents);
        item.addEventListener('mouseover', handleMouseEvents);
        item.addEventListener('mouseout',  handleMouseEvents);
        adjustDropdownPosition(item);
    });
};

initDesktopMenu();
window.addEventListener('resize', initDesktopMenu);

document.querySelectorAll('.sub_menu_3').forEach(megaMenu => {
    megaMenu.parentElement.parentElement.parentElement.classList.add('mega_menus');
});

// ── Mobile menu ──────────────────────────────────────
(function() {
    const contentMenu = document.querySelector('#__menu_content');
    const btnMobile   = document.getElementById('__mobile');
    const siteHeader  = document.getElementById('site-header');
    const nav         = document.getElementById('menu');

    const syncMobileMenuPosition = function() {
        if (!contentMenu) return;
        const anchor = nav || siteHeader;
        const bottom = anchor ? Math.max(0, anchor.getBoundingClientRect().bottom) : 60;
        contentMenu.style.top = bottom + 'px';
        contentMenu.style.height = 'calc(100dvh - ' + bottom + 'px)';
    };

    const setMobileMenuOpen = function(isOpen) {
        if (!contentMenu || !btnMobile) return;
        contentMenu.classList.toggle('show_menu_mobile', isOpen);
        btnMobile.classList.toggle('open', isOpen);
        btnMobile.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        document.body.classList.toggle('nh-mobile-menu-open', isOpen);
        if (isOpen) syncMobileMenuPosition();
    };

    if (btnMobile) {
        btnMobile.setAttribute('aria-expanded', 'false');
    }

    // Hamburger: siempre activo independiente del tamaño de pantalla
    if (btnMobile && contentMenu) {
        btnMobile.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            setMobileMenuOpen(!contentMenu.classList.contains('show_menu_mobile'));

            // Ajustar top del menú a la altura real del header
            const nav = document.getElementById('menu');
            if (nav) {
                const navBottom = nav.getBoundingClientRect().bottom;
                contentMenu.style.top = navBottom + 'px';
            }
        });
    }

    // Cerrar menu al hacer click fuera
    document.addEventListener('click', function(e) {
        if (contentMenu && btnMobile) {
            if (!contentMenu.contains(e.target) && !btnMobile.contains(e.target)) {
                setMobileMenuOpen(false);
            }
        }
    });

    window.addEventListener('resize', function() {
        if (contentMenu && contentMenu.classList.contains('show_menu_mobile')) {
            syncMobileMenuPosition();
        }
    });

    window.addEventListener('scroll', function() {
        if (contentMenu && contentMenu.classList.contains('show_menu_mobile')) {
            syncMobileMenuPosition();
        }
    }, { passive: true });

    // Submenus en mobile: click para expandir
    document.querySelectorAll('.has-submenu').forEach(function(item) {
        item.addEventListener('click', function(event) {
            if (window.innerWidth >= 950) return; // solo en mobile

            const clickedLink = event.target.closest('a');
            if (!clickedLink || clickedLink.closest('li') !== item) return;
            event.preventDefault();

            const isOpen = item.classList.contains('togle_menu');
            document.querySelectorAll('.has-submenu').forEach(function(el) {
                el.classList.remove('togle_menu');
                el.style.maxHeight = null;
            });
            if (!isOpen) {
                item.classList.add('togle_menu');
                item.style.maxHeight = item.scrollHeight + 500 + 'px';
            }
        });
    });
})();

// ── Read more ────────────────────────────────────────
var postContainers = document.querySelectorAll('div.content-read div.readmore');
if (postContainers.length) {
    postContainers.forEach(function(container) {
        if (container.clientHeight > container.parentElement.clientHeight) {
            container.parentElement.querySelector('div#fade').style.display = 'block';
            container.parentElement.querySelector('span#more').style.display = 'block';
        }
    });
    document.querySelectorAll('span#more').forEach(function(button) {
        button.addEventListener('click', function() {
            this.parentElement.style.maxHeight = '100%';
            this.style.display = 'none';
            this.parentElement.querySelector('div#fade').style.display = 'none';
            this.parentElement.querySelector('span#less').style.display = 'block';
        });
    });
    document.querySelectorAll('span#less').forEach(function(button) {
        button.addEventListener('click', function() {
            this.parentElement.style.maxHeight = '180px';
            this.style.display = 'none';
            this.parentElement.querySelector('div#fade').style.display = 'block';
            this.parentElement.querySelector('span#more').style.display = 'block';
        });
    });
}

// ── Header scroll behavior ───────────────────────────
(function () {
    const topbar = document.getElementById('nh-topbar');
    const navbar  = document.getElementById('menu');
    if (!navbar) return;

    window.addEventListener('scroll', function () {
        const y = window.scrollY;
        if (topbar) topbar.classList.toggle('collapsed', y > 40);
        navbar.classList.toggle('scrolled', y > 60);
    }, { passive: true });
})();
